import { render, staticRenderFns } from "./AdvancedProfile.vue?vue&type=template&id=06bf603a&"
import script from "./AdvancedProfile.vue?vue&type=script&lang=js&"
export * from "./AdvancedProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports